<template>
  <div class="options">
    <h2 class="options__title q-py-sm">
      Selecione uma opção<br>
      para realizar o embarque
    </h2>

    <q-btn @click="goPassengersList" color="white" text-color="black" unelevated class="card">
      <q-btn dense round flat class="text-grey-7 text-center q-mt-md q-mb-xs" style="font-size: 25px;" icon="check_circle_outline"/>
      <span class="options-title q-mb-xs">
        Conferencia de passageiros
      </span>
      <span class="options-subtitle q-mb-md">
        Realizar conferencia<br>
        dos passageiros
      </span>
    </q-btn>

    <q-btn @click="goPassengers" color="white" text-color="black" unelevated class="card">
      <q-btn dense round flat class="text-grey-7 text-center q-mt-md q-mb-xs" style="font-size: 25px;" icon="departure_board">
        <q-badge color="red" floating style="border-radius: 10px">
          <span class="text-bold">{{howManyPassengerStatus(false)}}</span>
        </q-badge>
      </q-btn>
      <span class="options-title q-mb-xs">
        Embarque de passageiros
      </span>
      <span class="options-subtitle q-mb-md">
        Realizar embarque<br>
        dos passageiros
      </span>
    </q-btn>


    <q-btn @click="goLuggages" color="white" text-color="black" unelevated class="card">
       <q-btn dense round flat class=" text-center q-mt-md q-mb-xs">
       <i style="font-size: 35px;" class="ri-suitcase-3-line text-grey-7 q-mt-md q-mb-xs"></i>
       <q-badge color="red" floating style="border-radius: 10px">
          <span class="text-bold">{{howManyLuggages()}}</span>
        </q-badge>
       </q-btn>
      <span class="options-title q-mb-xs">
        Listagens de Bagagens
      </span>
      <span class="options-subtitle q-mb-md">
        Realizar conferencia<br>
        dos Bagagens
      </span>
    </q-btn>

    <!-- <q-btn @click="goVoucherList" color="white" text-color="black" unelevated class="card options__bpe">
      <q-btn dense round flat class="text-grey-7 text-center" style="font-size: 25px;" icon="receipt"/>
      <span class="options-title">
        Emitir BPe pendentes
      </span>
      <span class="options-subtitle q-mb-md">
        Realiza a emissão<br>
        dos BPe pendentes na agência
      </span>
    </q-btn> -->

  </div>
</template>

<script>
import { readBoardingQRCode } from '../../functions'
import { mutations, store } from '../../store'

export default {
  name: 'Options',

  computed: {
    passengers: {
      get () {
        return store.passengers
      },
      set (value) {
        mutations.setPassengers(value)
      },
    }
  },
  methods: {
    readBoardingQRCode,

    goHome () {
      this.$router.push('/horarios')
    },

    goPassengers () {
      this.$router.push('/embarque/passageiros')
    },

    goLuggages () {
      this.$router.push('/passageiros/bagagens')
    },

    goPassengersList () {
      this.$router.push('passageiros/lista')
    },

    goVoucherList () {
      this.$router.push('/voucher')
    },

    howManyPassengerStatus (status) {
      return this.passengers.filter(v => v.boarding_status === status).length
    },

    howManyLuggages () {
      let count = 0;

      for (const passenger of this.passengers) {
        if (passenger.luggages) {
          count += passenger.luggages.length;
        }
      }
      return count
    },
  },
}
</script>

<style lang="scss">
$icon-size: 70px;

.options-title {
  font-size: 12px;
  line-height: normal;
  color: #092c1e;
  font-weight: 600;
  text-transform: uppercase;
}

.options-subtitle {
  font-size: 12px;
  color: #7a8583;
  line-height: 1;
  text-transform: initial;
}

.options {
  display: grid;

  grid-column-gap: 10px;
  grid-row-gap: 12px;

  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "title title"
    "other other"
    "bpe bpe";

  width: 90%;
  margin: auto;
}

.options__bpe {
  grid-area: bpe;

  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: normal;
  color: #000000;
}

.options__title {
  grid-area: title;

  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: normal;
  color: #000000;
}
</style>
